import React, { useEffect, useState } from 'react';
import OrganizerInfo from '../../components/organizer/OrganizerInfo';
import GetListings from '../../components/listing/GetListings';
import LoadingScreen from '../../components/utilities/LoadingScreen';
function OrganizerDetail({ regionName, organizerName }) {
  const [organizer, setOrganizer] = useState(null);
  const [places, setPlaces] = useState([]);
  const [region, setRegion] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    // Fetch region details when the component mounts
    fetchOrganizer();
  }, [organizerName]);
  useEffect(() => {
    if(organizer) {
      document.title = `${organizer.name} - Zeitgeists`;
    } else {
      document.title = `Organizer - Zeitgeists`;
    }
  }, [organizer]);

  const fetchOrganizer = async () => {
    try {
      const response = await fetch(`/api/region/${regionName}/organizer/${organizerName}`, {
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });
      if (response.ok) {
        const data = await response.json();
        setOrganizer(data.organizer);
        setPlaces(data.places);
        setRegion(data.region);
        setLoading(false);
      }
    } catch (error) {
      // Handle error
    }
  };

  return (
    <LoadingScreen isLoading={loading}  message="Fetching organizer...">
    <div className="grid grid-cols-3 gap-4 mt-16">
      <div className="col-span-3 md:col-span-1">
      {organizer && <OrganizerInfo places={places} organizer={organizer}/>}
      </div>
      
 


<div className="col-span-3 md:col-span-2">

      {organizer &&   (
        <div className="m-4">
        <GetListings organizers={[organizer.id]} />
        </div>
      )}
</div>
    </div>
    </LoadingScreen>
  );
}

export default OrganizerDetail;
